// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import stylesDef from './styles';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { RootState } from 'Store';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { GetAdminOrderAdjustmentsRoute } from 'Utils/routes';
import { useNavigate, useParams } from 'react-router-dom';
import OrderAdjustmentCard from '../orderAdjustmentCard';
import { SetOrgIdAction } from 'Features/admin/adminActions';
import { GetOrgThunk } from 'Features/admin/adminThunk';

const ViewAllAdjustments: React.FC = () => {
  // Constants
  const theme = useTheme();
  const styles = stylesDef(theme);
  const { selectedOrderAdjustment } = useAppSelector((state: RootState) => state.admin);
  const { orgId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // State Variables
  const [formattedOrderAdjustments, setFormattedOrderAdjustments] = useState<IOrderAdjustmentsDetails[]>([]);

  //useEffects
  useEffect(() => {
    const loadData = async () => {
      if (_ADMIN_) {
        await Promise.all([
          dispatch(GetOrgThunk(orgId)),
          dispatch(SetOrgIdAction(orgId))
        ]);
      }
    };
    
    loadData();
  }, []);
  
  useEffect(() => {
    if (selectedOrderAdjustment) {
      const data: IOrderAdjustmentsDetails[] = selectedOrderAdjustment.orderAdjustments.map((item) => ({
        projectName: selectedOrderAdjustment.projectName,
        projectId: selectedOrderAdjustment.projectId,
        orderAdjustments: [item],
      }));
      setFormattedOrderAdjustments(data);
    }
  }, [selectedOrderAdjustment]);

  // Methods
  const handleBackClick = () => {
    navigate(GetAdminOrderAdjustmentsRoute(orgId));
  };

  return (
    <Box sx={styles.pageWrapper}>
      <Box sx={styles.headerSection}>
        <KeyboardBackspaceIcon sx={styles.backButton} onClick={handleBackClick} />
        <Typography variant="h6" sx={styles.headerText}>{`${selectedOrderAdjustment?.projectName} (Adjustment History)`}</Typography>
      </Box>
      <Divider sx={styles.divider} />
      {formattedOrderAdjustments && formattedOrderAdjustments.length > 0 && formattedOrderAdjustments.map((item, index) => (
        <OrderAdjustmentCard key={item?.orderAdjustments[0]?.id} orderAdjustment={item} />
      ))}
    </Box>
  )
}

export default ViewAllAdjustments
